import { OnboardingBenefitsStep } from "@/blocks/OnboardingBenefitsStep";
import { OnboardingConcernsStep } from "@/blocks/OnboardingConcernsStep";
import { OnboardingIntroStep } from "@/blocks/OnboardingIntroStep";
import { OnboardingNextStepsStep } from "@/blocks/OnboardingNextStepsStep";

import { OnboardingVariantType } from "../types";

export const defaultVariant: OnboardingVariantType = {
  steps: [
    { Component: OnboardingIntroStep },
    { Component: OnboardingBenefitsStep },
    { Component: OnboardingConcernsStep },
    { Component: OnboardingNextStepsStep },
  ],
};
